export const getFormattedNumber = (num: number | string, separator = ' '): string => {
	return String(num)
		.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};
